<mat-card fxLayout="column" style="flex: 1; overflow-y: auto;">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <article>
            <h4 class="chart-two-heading">SESSION DATA</h4>
        </article>
    </div>
 
    <mat-card-content fxLayout="column" style="flex: 1;" fxLayoutAlign="start stretch">
        <div *ngIf="totalDifficultPSets?.length === 0 && !isMessage" class="empty-state-spinner">
            <mat-spinner diameter="20"></mat-spinner>
        </div>
        <span *ngIf="isMessage" class="empty-state-text title-sm">No Sessions</span>
        <div fxLayout="column" style="flex: 1;" [fxHide]="totalDifficultPSets ? totalDifficultPSets?.length == 0 : true">
            <div fxLayout="row" overflowAuto style="max-height: 300px; overflow-y: auto;">
                <table mat-table [dataSource]="dataSource" matSort matSortActive="averageCorrectAnswers"
                    matSortDirection="asc" class="mat-elevation-z8 ovrflw" aria-label="Session Data list">
                    <ng-container matColumnDef="sessionDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Session Date </th>
                        <td mat-cell *matCellDef="let element" class="brk_txt" [matTooltip]="element.sessionDateStr">
                            {{ element.sessionDateStr }}</td>
                    </ng-container>
 
                    <ng-container matColumnDef="duration">
                        <th mat-header-cell *matHeaderCellDef scope="col"> Duration </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.duration }}
                        </td>
                    </ng-container>   -->
 
                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator class="analytic-paginator" style="margin-top: auto;"
                [pageSize]="5" [length]="totalDifficultPSets?.length" [style.display]="isPage?'none':''"
                [pageSizeOptions]="[5, 10, 25, 100]">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>